import { Component, computed, ElementRef, inject, signal, ViewChild, AfterViewInit } from '@angular/core';
import { catchError, interval, of, Subscription, tap } from 'rxjs';
import { JobOperationService } from 'src/app/modules/shared/services/job-operation.service';
import { LoadingService, NotificationService } from 'src/app/core';
import { JobDTO } from 'src/app/modules/shared/interface/jop-operation.entity';
import { StatusBadgeComponent } from 'src/app/modules/shared/components/status-badge/status-badge.component';
import { CommonModule } from '@angular/common';
import { CountDTO, JobCardFindDTO } from 'src/app/modules/job-operation/interfaces/job-card.entity';
import { JobCardService } from 'src/app/modules/job-operation/services/job-card.service';
import { DepartmentService } from 'src/app/modules/shared/services/department.service';
import { Department, DepartmentDTO, Machine, MachineDTO, Output } from 'src/app/modules/shared/interface/department.entity';
import { FormsModule } from '@angular/forms';
import { MachineService } from 'src/app/modules/shared/services/machine.service';
import { MachineCurrentShiftDTO } from 'src/app/modules/shared/interface/machine.entity';
import { GlobalDepartmentService } from 'src/app/core/services/global-department.service';
import { animate, style, transition, trigger } from '@angular/animations';
// @Component({
//   selector: 'app-dashboard',
//   imports: [
//     StatusBadgeComponent,
//     CommonModule,
//     FormsModule,
//   ],
//   templateUrl: './dashboard.component.html',
//   styleUrl: './dashboard.component.scss',
// })
@Component({
  selector: 'app-dashboard',
  imports: [
    StatusBadgeComponent,
    CommonModule,
    FormsModule,
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(8px)' }),
        animate('250ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
      ]),
    ]),
  ],
})
export class DashboardComponent implements AfterViewInit {
  @ViewChild('todayTable') todayTable!: ElementRef<HTMLDivElement>;
  @ViewChild('failedTable') failedTable!: ElementRef<HTMLDivElement>;

  public jobOperationService = inject(JobOperationService);
  public notification = inject(NotificationService);
  public jobCardService = inject(JobCardService);
  public loading = inject(LoadingService);
  public departmentService = inject(DepartmentService);
  public machineService = inject(MachineService);
  public globalDepartmentService = inject(GlobalDepartmentService);

  protected $$jobCardFindDTOS = signal<JobCardFindDTO[]>([]);
  protected $$jobDTOS = signal<JobDTO[]>([]);
  protected $$CountDTO = signal<CountDTO[]>([]);
  protected $$departmentDTO = signal<Department[]>([]);
  protected $$availableMachines = signal<Machine[]>([]);
  protected $$allMachines = signal<Machine[]>([]);
  protected $$Impressions = signal<DepartmentDTO[]>([]);
  protected $$machineCurrentShiftDTO = signal<MachineCurrentShiftDTO[]>([]);

  protected currentTodayPage = signal(0);
  protected currentFailedPage = signal(0);

  protected readonly $$totalItems = signal(0);
  protected readonly $$pageNumber = signal(1);
  protected readonly $$itemsPerPage = signal(1);

  protected totalJobs: number = 0;
  protected inProgressJobs: number = 0;
  protected completedJobs: number = 0;
  protected onHoldJobs: number = 0;
  protected dispatchedJobs: number = 0;
  currentTime: string = '';
  currentDate: string = '';
  private clockSub?: Subscription;
  readonly itemsPerPage = 10;
  showFilters: boolean = false;
  protected departmentId = this.globalDepartmentService.selectedDepartmentId;
  machineId: number | null = null;
  Year = signal(new Date().getFullYear());
  Month = signal(new Date().getMonth());
  selectedYear: number = this.Year();
  selectedMonth: number = this.Month();
  months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];
  years: number[] = [];
  selectedDate = signal<string>(this.formatDate(new Date()));
  private today = new Date();

  @ViewChild('machineContainer') machineContainer!: ElementRef<HTMLDivElement>;
  private scrollIntervals: Map<ElementRef<HTMLDivElement>, number> = new Map();

  ngOnInit(): void {
    this.fetchPOData();
    this.count();
    // setInterval(() => this.fetchPOData(), 60 * 60 * 1000);
    // setInterval(() => this.count(), 60 * 60 * 1000);
    // setInterval(() => this.getImpressionDetails(), 60 * 60 * 1000);
    this.clockSub = interval(1000).subscribe(() => {
          this.currentTime = new Date().toLocaleTimeString();
          this.currentDate = new Date().toLocaleDateString();
        });
    this.fetchDepartment();
    
    const currentDeptId = this.departmentId();
    if (currentDeptId !== null) {
      // this.getImpressionDetails(currentDeptId);
      this.getMachineCurrentShifts(currentDeptId);
    }
  }

  count() {
    const id = this.departmentId();
    if (id === null) return;

    this.jobCardService.countFind(id).subscribe({
      next: (res) => {
        // console.log('CountDTO:', res.data);

        this.totalJobs = res.data.totalJobs;
        this.inProgressJobs = res.data.inProgressJobs;
        this.completedJobs = res.data.completedJobs;
        this.onHoldJobs = res.data.holdJobs;
        this.dispatchedJobs = res.data.dispatchedJobs
      },
      error: (err) => {
        console.error('Failed to load job counts:', err);
      }
    });
  }

  ngAfterViewInit(): void {
      if (this.todayTable) {
        this.startAutoScroll(this.todayTable, 60); 
      }
      if (this.failedTable) {
        this.startAutoScroll(this.failedTable, 60); 
      }
      if (this.machineContainer) {
      this.startAutoScrollX(this.machineContainer, 40); 
    }
  }

  private startAutoScroll(table: ElementRef<HTMLDivElement>, speed: number): void {
    if (!table?.nativeElement) return;

    const element = table.nativeElement;
    let scrollPosition = 0;

    const scroll = () => {
      scrollPosition += 1; 
      element.scrollTop = scrollPosition;

      if (scrollPosition >= element.scrollHeight - element.clientHeight) {
        scrollPosition = 0;
        element.scrollTop = 0;
      }
    };

    const intervalId = window.setInterval(scroll, speed);
    this.scrollIntervals.set(table, intervalId);

    element.addEventListener('mouseenter', () => {
      const currentInterval = this.scrollIntervals.get(table);
      if (currentInterval) {
        clearInterval(currentInterval);
        this.scrollIntervals.delete(table);
      }
    });

    element.addEventListener('mouseleave', () => {
      if (!this.scrollIntervals.has(table)) {
        const newIntervalId = window.setInterval(scroll, speed);
        this.scrollIntervals.set(table, newIntervalId);
      }
    });
  }

  ngOnDestroy(): void {
    this.scrollIntervals.forEach((intervalId, table) => {
      clearInterval(intervalId);
    });
    this.scrollIntervals.clear();
  }

  public fetchPOData(): void {
    const id = this.departmentId();
    if (id === null) return;

    this.loading.set(true);
    this.jobOperationService.deliveryFind(id).pipe(
      tap(response => {
        this.$$jobDTOS.set(response.data);
        this.loading.set(false);
      }),
      catchError(error => {
        this.loading.set(false);
        this.notification.set({ type: 'error', message: `Failed to fetch PO data` });
        console.error(error);
        return of(null);
      })
    ).subscribe();
  }

  //new


  public isTodayOrTomorrow(deliveryDate: string | Date): boolean {
    const jobDate = new Date(deliveryDate);
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);

    return jobDate.toDateString() === today.toDateString() || jobDate.toDateString() === tomorrow.toDateString();
  }

  protected readonly $$todayOrTomorrowJobs = computed(() =>
    this.$$jobDTOS().filter(job => this.isTodayOrTomorrow(job.deliveryDate))
  );

  public isFailedJob(deliveryDate: string | Date): boolean {
    const jobDate = new Date(deliveryDate);
    const today = new Date();

    return jobDate < today && jobDate.toDateString() !== today.toDateString();
  }

  protected readonly $$failedJobs = computed(() =>
    this.$$jobDTOS().filter(job => job.deliveryDate && this.isFailedJob(job.deliveryDate) && job.dispatchQuantity == 0)
  );

  get progressPercentage(): number {
    const denominator = this.totalJobs;
    if (denominator <= 0) return 0;
    return Math.round((this.inProgressJobs / denominator) * 100);
  }

   get completePercentage(): number {
    const denominator = this.totalJobs;
    if (denominator <= 0) return 0;
    return Math.round((this.completedJobs / denominator) * 100);
  }

getMachineUtilization(machine: Output): number {
  if (!machine.plannedImpression || machine.actualImpression <= 0) return 0;
  return Math.min(Math.round((machine.actualImpression / machine.plannedImpression ) * 100));
}

public fetchDepartment(): void {
  this.departmentService.getAllDepartments().subscribe({
    next: (result) => {
      if (result.data && result.data.departments) {
        const departments = result.data.departments;
        this.$$departmentDTO.set(result.data.departments);
        const machines = departments.reduce((acc: Machine[], dept: Department) => {
          if (dept.machines) {
            return acc.concat(
              dept.machines.filter(m => m && m.machineId && m.machineName)
            );
          }
          return acc;
        }, []);

        this.$$allMachines.set(machines);
        //console.log('All Machines:', this.$$allMachines());
      }
    },
    error: (error) => {
      console.error('Error fetching departments:', error);
    }
  });
}

private startAutoScrollX(container: ElementRef<HTMLDivElement>, speed: number): void {
  if (!container?.nativeElement) return;

  const element = container.nativeElement;
  let scrollPosition = 0;

  const scroll = () => {
    scrollPosition += 1; 
    element.scrollLeft = scrollPosition;

    if (scrollPosition >= element.scrollWidth - element.clientWidth) {
      scrollPosition = 0;
      element.scrollLeft = 0;
    }
  };

  const intervalId = window.setInterval(scroll, speed);
  this.scrollIntervals.set(container, intervalId);

  element.addEventListener('mouseenter', () => {
    const currentInterval = this.scrollIntervals.get(container);
    if (currentInterval) {
      clearInterval(currentInterval);
      this.scrollIntervals.delete(container);
    }
  });

  element.addEventListener('mouseleave', () => {
    if (!this.scrollIntervals.has(container)) {
      const newIntervalId = window.setInterval(scroll, speed);
      this.scrollIntervals.set(container, newIntervalId);
    }
  });
}

onDepartmentChange(departmentId: number): void {
    this.globalDepartmentService.setDepartmentId(departmentId);
    
    const selectedDepartment = this.$$departmentDTO().find(
      dept => dept.departmentId === departmentId
    );

    if (selectedDepartment) {
      this.$$availableMachines.set(selectedDepartment.machines || []);
      this.machineId = null; 
    } else {
      this.$$availableMachines.set([]);
      this.machineId = null;
    }
    // this.getImpressionDetails(departmentId);
    this.fetchPOData();
    this.count();
    this.getMachineCurrentShifts(departmentId);
  }


  protected searchParams = signal({
      year: this.today.getFullYear(),
      month: this.today.getMonth() + 1,
      day: this.today.getDate()
  });

  // getImpressionDetails(depId: number) {
  //   this.loading.set(true);
  //   if(this.departmentId()) {
  //     this.departmentService.getPlannedandActualImpressions(depId, this.searchParams())
  //       .pipe(
  //         tap(response => {
  //           this.loading.set(false);
  //           this.$$Impressions.set([response.data])
  //         }),
  //         catchError(error => {
  //           this.loading.set(false);
  //               this.notification.set({ type: 'error', message: `Failed to fetch Job Impression data` });
  //               console.error(error);
  //               return of(null);
  //         })
  //       ).subscribe();
  //   }
  // }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  onDateChange(event: any) {

    let value = event.target.value;

    if (!value) {
      value = new Date().toISOString().split('T')[0];
      this.today = value;
    }

    const date = new Date(value);
      this.selectedDate.set(value);

    this.searchParams.set({
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    });

    const currentDeptId = this.departmentId();
    // if (currentDeptId !== null) {
    //   this.getImpressionDetails(currentDeptId); 
    // }
  }

  getSelectedDepartmentName(): string {
      const dept = this.$$departmentDTO()
          ?.find(d => d.departmentId == this.departmentId());

      return dept ? dept.departmentName : 'Select Department';
  }

  getMachineCurrentShifts(departmentId: number) {
    this.machineService.getMachineCurrentShifts(departmentId).subscribe({
      next: (res) => {
        if (res?.data) {
          this.$$machineCurrentShiftDTO.set([res.data]);
        }
      },
      error: (err) => {
        console.error('Error fetching machine current shifts', err);
      }
    });
  }

  // getMachineShift(machineName: string) {
  //   const shifts = this.$$machineCurrentShiftDTO();

  //   if (!shifts || shifts.length === 0) return null;

  //   const machineShift = shifts
  //     .flatMap(dep => dep.machines ?? [])
  //     .find(m => m.machineName === machineName);

  //   return machineShift || null;
  // }



}